import StockList from '../../../components/Main/Stock/StockList'
import withSort from '../../../elements/HOC/withSort'
import useModalShow from '../../../elements/Hooks/useModalShow'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withData from '../../../elements/Select/withData'
import { defaultFormItemLayout } from '../../../modules/FormItems'
import React, { useState } from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Checkbox, Col, Form, Modal } from 'antd'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import { groupBy, get } from 'lodash'
import { compose } from 'recompose'

const FilterBySelect = compose(
  withData({
    data: [
      { key: 'product._id', value: 'By Product' },
      { key: 'productLine._id', value: 'By SKU' },
    ],
  }),
  withSort
)(CustomSelect)

function InventoryList(props) {
  const { list, fetch, fetching, company, onChangeCompany } = props

  const [filter, setFilter] = useState(false)
  const [grouping, setGrouping] = useState('product._id')
  const { payload, visible, onShow, onCancel } = useModalShow()

  const columns = [
    {
      Header: 'Product',
      accessor: 'product.name',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'list')}>{value}</a>,
    },
    { Header: 'SKU', accessor: 'productLine.name' },
    { Header: 'category', accessor: 'category.name' },
    { Header: 'group', accessor: 'group.name' },
    { Header: 'Stock', accessor: 'stock' },
    { Header: 'Company', accessor: 'company.fn' },
    { Header: 'Location', accessor: 'location' },
    { Header: 'OnSold', accessor: 'onSell' },
    { Header: 'onOrder', accessor: 'onOrder' },
    { Header: 'Sold', accessor: 'sold' },
    { Header: 'Bought', accessor: 'bought' },
  ]

  const inventory = Object.values(groupBy(list, grouping)).map((stock) => {
    const sold = stock.filter((i) => i.type === 'debit').reduce((acc, v) => acc + v.unit, 0)
    const bought = stock.filter((i) => i.type === 'credit').reduce((acc, v) => acc + v.unit, 0)
    const onOrder = stock.reduce((acc, v) => acc + (v.onOrder || 0), 0)
    const onSell = stock.reduce((acc, v) => acc + (v.onSell || 0), 0)
    return {
      product: get(stock, '[0]product'),
      productLine: get(stock, '[0]productLine'),
      category: get(stock, '[0]category'),
      group: get(stock, '[0]group'),
      stock: bought - sold,
      company: get(stock, '[0]company'),
      location: '',
      sold,
      bought,
      list: stock,
      onOrder,
      onSell,
    }
  })

  return (
    <>
      <Modal visible={visible} title={'Stock'} onCancel={onCancel} destroyOnClose={true} width={'75%'}>
        <StockList {...{ ...props, list: get(payload, 'object.list', []) }} />
      </Modal>

      <CustomTable
        data={filter ? inventory.filter((i) => i.stock > 0) : inventory}
        defaultPageSize={20}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
        CreateButton={() => (
          <>
            <Col span={3}>
              <Checkbox onChange={() => setFilter((e) => !e)} defaultChecked={filter} />
              <span style={{ marginLeft: 10 }}>Show Stock only</span>
            </Col>
            <Col span={5}>
              <Form.Item {...defaultFormItemLayout} label="Group By">
                <FilterBySelect value={grouping} onChange={(e) => setGrouping(e)} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </>
        )}
        columns={columns}
        ExtraOptionsButtons={() => (
          <OrganisationsSelect
            value={company}
            onChange={onChangeCompany}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{ width: '450px', paddingRight: 20, float: 'right' }}
          />
        )}
        defaultSorted={[
          {
            id: '_key',
            desc: false,
          },
        ]}
      />
    </>
  )
}

InventoryList.propTypes = {}
InventoryList.defaultProps = {}

export default InventoryList
